import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import Arabic from "./locales/ar/translation.json";
import English from "./locales/en/translation.json";

export const SUPPORTED_LANGS = ["en", "ar"];
export const DEFAULT_LANG = "en";

const resources = {
  en: { translation: English },
  ar: { translation: Arabic },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    detection: {
      order: ["path", "navigator"],
    },
    interpolation: {
      escapeValue: false,
    },
    resources,
    debug: true,
  });

export default i18n;
